import React from 'react';
import PropTypes from 'prop-types';

import DatesRangeSelector from 'components/form/RecurringForm/components/DatesRangeSelector/styled';
import WeekDaysSelector from 'components/form/RecurringForm/components/WeekDaysSelector/styled';

const RecurringForm = ({ className, t }) => (
  <div className={`${className}`}>
    <h1 className="title">{t('form.title')}</h1>
    <DatesRangeSelector t={t} />
    <WeekDaysSelector t={t} />
  </div>
);

RecurringForm.propTypes = {
  className: PropTypes.string,
  t: PropTypes.func,
};

RecurringForm.defaultProps = {
  className: '',
  t: (t) => t,
};

export default RecurringForm;
